import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyMechanicCommissionTop = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/mechanics/commissions',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
